{
  "release": "3.0.3",
  "commit": "4bc46095",
  "date": "2026-11-04T11:23:27Z"
}
